import { render, staticRenderFns } from "./FormsAnalysis.vue?vue&type=template&id=49c6f6b7&"
import script from "./FormsAnalysis.vue?vue&type=script&lang=js&"
export * from "./FormsAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports